var _defs, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSorgeniaCri1 = function SvgSorgeniaCri1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 200 123.29",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 169.78,
    y1: 61.64,
    x2: 2.17,
    y2: 61.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#98d529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#7cb136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#5d8745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#426552"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2e4a5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#1f3763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#172c67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#142868"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.62,80.85c-2.43,18.09-15.31,27.41-30.56,27.41-17,0-31-11.62-31-33.8,0-21.7,14-33.8,31-33.8,15.33,0,27.24,9.35,30.24,25.55h-15C88.6,58.1,82.53,54.12,75.06,54.12c-9.62,0-17,6.49-17,20.34s7.3,20.34,17,20.34c8.08,0,14.81-4.5,15.87-14ZM166,107H149.54l-12.87-23.4H124.78v23.42H110.35V42l30.08,0c14.18,0,22.8,10.25,22.8,21,0,8.35-4.85,16.38-12.52,19.21ZM141.56,71c5,0,9.07-3,9.07-8.06s-4.06-8.34-9.07-8.34H124.78V71Zm41.94,36H170.12V42H183.5ZM16.5,15V83.32h.44C20.93,62,41.3,19.47,144.05,15.48V15Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSorgeniaCri1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Sorgenia_CRI_1.51d5d335.svg";
export { ForwardRef as ReactComponent };